/**
 * 스키마 변환기 등록소.
 *
 * 한 항목이 버전 하나를 올린다. `from` 오름차순으로 이어 붙여 최신까지 올린다.
 *
 * 버전을 언제 올리나
 * -----------------
 * 저장된 모델을 **예전 빌드가 잘못 읽을** 변경을 했을 때만 올린다.
 *
 * - 올린다: 필드 이름 변경, 값의 의미 변경, 필드 제거, 구조 재배치
 * - 올리지 않는다: 필드를 더하기만 하는 변경. 예전 빌드는 모르는 키를 무시하므로
 *   호환이 깨지지 않는다. 버전을 올리면 옛 빌드에서 못 열게 될 뿐이다.
 *
 * 새 변환을 추가할 때
 * -------------------
 * 1. `index.js` 의 `CURRENT_SCHEMA_VERSION` 을 올린다.
 * 2. 여기에 `{ from, to, structural, describe, migrate }` 를 추가한다.
 * 3. `structural: true` 로 두면 호출자가 **원본을 두고 복제본을 변환**한다.
 *    필드 하나 채우는 정도의 보정이면 `false`(lossless) 로 둔다.
 * 4. `__fixtures__` 에 그 버전으로 저장된 표본을 넣고 테스트를 추가한다.
 *    표본이 다음 변경 때 회귀 테스트가 된다.
 *
 * 변환기가 지켜야 할 두 가지
 * -------------------------
 * 1. **새 객체를 돌려준다.** 입력을 그대로 고치면 안 된다(복제 전 원본이 들어올 수 있다).
 * 2. **버전이 아니라 모양으로 판정하고, 다시 돌려도 아무 일이 없어야 한다.**
 *    버전 필드를 모르는 예전 빌드가 모델을 다시 저장하면 최신 모델도 v0 으로 되돌아온다.
 *    그러면 이 목록의 변환이 처음부터 다시 돌아간다. 그때 이미 변환된 모델이 또 바뀌면
 *    데이터가 망가진다. 각 단계는 "이 모양이면 바꾼다" 로 쓴다.
 *    (openflow 가 같은 문제를 먼저 겪고 SCHEMA_COMPAT.md 에 규칙으로 남겼다.)
 */

/**
 * v0 → v1 : 버전 표시가 없던 시절의 데이터.
 *
 * 구조 자체는 지금과 같다. 다만 나중에 생긴 필드(배타적 관계·서브타입 그룹·모델 설정)가
 * 아예 없을 수 있어서, 읽는 쪽이 매번 `|| []` 로 막고 있었다. 그 보정을 한 곳으로 옮긴다.
 * 잃는 것이 없으므로 lossless — 복제 없이 그대로 열고 그대로 저장한다.
 */
const v0_to_v1 = {
  from: 0,
  to: 1,
  structural: false,
  describe: '버전 표시가 없던 데이터 — 누락 필드 보정',
  migrate: (model) => ({
    ...model,
    // normalizeModelPayload 가 이미 배열/객체를 보장하지만, 변환기는 단독으로도
    // 옳게 동작해야 하므로 여기서도 확인한다.
    nodes: Array.isArray(model.nodes) ? model.nodes : [],
    edges: Array.isArray(model.edges) ? model.edges : [],
    attrs: Array.isArray(model.attrs) ? model.attrs : [],
    exclusiveGroups: Array.isArray(model.exclusiveGroups) ? model.exclusiveGroups : [],
    subtypeGroups: Array.isArray(model.subtypeGroups) ? model.subtypeGroups : [],
    modelConfig: model.modelConfig && typeof model.modelConfig === 'object' ? model.modelConfig : {},
  }),
};

export const MIGRATIONS = [v0_to_v1];

export default MIGRATIONS;
